'use client'

import * as Avatar from '@radix-ui/react-avatar'
import { tw } from 'utils/classnames'

// eslint-disable-next-line no-barrel-files/no-barrel-files
// oxlint-disable-next-line cf-web/no-barrel-file
export * from '@radix-ui/react-avatar'

export type AvatarColorVariant = 'primary' | 'secondary'
export type RootProps = Avatar.AvatarProps & {
  // show an outline/border around the avatar.
  outline?: boolean
  size?:
    | 'xSmall'
    | 'small'
    | 'medium'
    | 'mediumSecondary'
    | 'mediumTertiary'
    | 'mediumLarge'
    | 'semiLarge'
    | 'midLarge'
    | 'large'
    | 'largeSecondary'
    | 'largeThird'
    | 'largeTertiary'
    | 'xLarge'
    | 'xxLarge'
  rounded?: 'full' | 'rounded'
  variant?: AvatarColorVariant
}
const sizeClasses = {
  xSmall: 'min-w-4 size-4',
  small: 'min-w-6 size-6',
  medium: 'min-w-8 size-8',
  mediumSecondary: 'min-w-9 size-9',
  mediumTertiary: 'min-w-10 size-10',
  mediumLarge: 'min-w-12 size-12',
  semiLarge: 'min-w-14 size-14',
  midLarge: 'min-w-16 size-16',
  large: 'min-w-[72px] w-[72px] h-[72px]',
  largeSecondary: 'min-w-20 size-20',
  largeTertiary: 'min-w-[88px] size-[88px]',
  largeThird: 'min-w-24 size-24',
  xLarge: 'min-w-28 size-28',
  xxLarge: 'min-w-40 size-40',
}
export function Root({ outline, rounded = 'full', variant = 'secondary', ...props }: RootProps) {
  return (
    <Avatar.Root
      {...props}
      className={tw(
        // size
        sizeClasses[props.size ?? 'medium'],
        // appearance
        'text-service-white overflow-hidden bg-gray-700 text-base',
        // position
        'flex place-content-center place-items-center',
        // border or no border?
        outline && 'outline outline-[3px] outline-gray-900',
        // default circle or variant rounded corners
        rounded === 'full' && 'rounded-full',
        rounded === 'rounded' && 'rounded-2',
        variant === 'primary' && 'bg-violet-500',
        variant === 'secondary' && 'bg-gray-700',
        props.className,
      )}
    />
  )
}

export function Image(props: Avatar.AvatarImageProps) {
  return (
    <Avatar.Image
      {...props}
      className={tw('h-full w-full rounded-[inherit] object-cover', props.className)}
    />
  )
}

export const Fallback = ({ delayMs = 600, ...props }) => (
  <Avatar.Fallback delayMs={delayMs} {...props} />
)

export function Skeleton({
  outline,
  rounded = 'full',
  variant = 'secondary',
  ...props
}: RootProps) {
  return (
    <div
      className={tw(
        // size
        sizeClasses[props.size ?? 'medium'],
        // appearance
        'text-service-white overflow-hidden rounded-full bg-gray-700 text-base',
        // position
        'flex place-content-center place-items-center',
        // border or no border?
        outline && 'outline outline-[3px] outline-gray-900',
        // default circle or variant rounded corners
        rounded === 'full' && 'rounded-full',
        rounded === 'rounded' && 'rounded-2',
        variant === 'primary' && 'bg-violet-500',
        variant === 'secondary' && 'bg-gray-700',
        props.className,
      )}
    />
  )
}
